import { getFromLocalStorageByKey, removeFromLocalStorage, saveToLocalStorage } from './index';

const localStorageKeys = {
  DEVICE_MENU_BREADCRUMBS: 'DEVICE_MENU_BREADCRUMBS',
  MENU_ID: 'MENU_ID',
};

export const getBreadcrumbsFromLocalStorage = () => getFromLocalStorageByKey(localStorageKeys.DEVICE_MENU_BREADCRUMBS);
export const setBreadcrumbsToLocalStorage = value =>
  saveToLocalStorage(localStorageKeys.DEVICE_MENU_BREADCRUMBS, value);
export const removeBreadcrumbsFromLocalStorage = () => removeFromLocalStorage(localStorageKeys.DEVICE_MENU_BREADCRUMBS);

export const getMenuIdFromLocalStorage = () => getFromLocalStorageByKey(localStorageKeys.MENU_ID);
export const setMenuIdToLocalStorage = value => saveToLocalStorage(localStorageKeys.MENU_ID, value);
export const removeMenuIdFromLocalStorage = () => removeFromLocalStorage(localStorageKeys.MENU_ID);
export const removeLocalStorageDeviceMenuKeys = () => {
  removeBreadcrumbsFromLocalStorage();
  removeMenuIdFromLocalStorage();
};
